/**
 * Parse inbound From headers for inbox / webhook alignment with
 * supabase/functions/_shared/email-classify.ts (extractEmail).
 *
 * @param {string} sender
 * @returns {string|null}
 */
export function extractInboundEmail(sender) {
  if (!sender || typeof sender !== 'string') return null;
  const trimmed = sender.trim();
  const match = trimmed.match(/<([^>]+)>/);
  if (match) return match[1].toLowerCase().trim();
  if (trimmed.includes('@')) return trimmed.toLowerCase().trim();
  return null;
}
